import { ArrowUpRight } from "lucide-react";
import React from "react";
import {
  FaGoogle,
  FaMicrosoft,
  FaAmazon,
  FaApple,
  FaGithub,
  FaSlack,
  FaFigma,
  FaSpotify,
} from "react-icons/fa";
import { Link } from "react-router-dom";

const companies = [
  {
    icon: <FaGoogle />,
    color: "text-red-500",
    name: "Google",
  },
  {
    icon: <FaMicrosoft />,
    color: "text-blue-500",
    name: "Microsoft",
  },
  {
    icon: <FaAmazon />,
    color: "text-yellow-500",
    name: "Amazon",
  },
  {
    icon: <FaApple />,
    color: "text-black dark:text-white",
    name: "Apple",
  },
  {
    icon: <FaGithub />,
    color: "text-gray-800 dark:text-white",
    name: "GitHub",
  },
  {
    icon: <FaSlack />,
    color: "text-pink-500",
    name: "Slack",
  },
  {
    icon: <FaFigma />,
    color: "text-purple-500",
    name: "Figma",
  },
  {
    icon: <FaSpotify />,
    color: "text-green-500",
    name: "Spotify",
  },
];

export default function Topcompanies() {
  return (
    <section className="relative py-16 px-4 sm:px-6 lg:px-16 overflow-hidden bg-[#f8f8f8] dark:bg-[#050505] text-gray-900 dark:text-white">
      {/* BACKGROUND */}
      <div className="absolute top-0 left-0 w-[400px] h-[400px] bg-primary/10 blur-[120px] rounded-full"></div>
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-orange-300/10 blur-[120px] rounded-full"></div>

      {/* GRID */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(0,0,0,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.03)_1px,transparent_1px)] dark:bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:60px_60px]"></div>

      <div className="relative z-10 max-w-7xl mx-auto ">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          {/* LEFT */}
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-primary/20 bg-white/60 dark:bg-white/5 backdrop-blur-xl mb-6">
              <span className="w-2 h-2 rounded-full bg-primary animate-pulse"></span>
              <span className="text-sm tracking-wide font-medium">
                Powered By Modern Technologies
              </span>
            </div>

            <h2 className="myheading text-3xl md:text-5xl mb-6">
              Serve Next-Level
              <span className="bg-gradient-to-r from-primary via-orange-400 to-yellow-500 bg-clip-text text-transparent">
                {" "}
                Digital Products
              </span>
            </h2>

            <p className="myparagraph  text-gray-600 dark:text-gray-400 max-w-xl mb-6">
              We build modern web experiences inspired by world-class design
              systems, innovative technologies, and scalable development
              practices trusted across the global digital ecosystem.
            </p>

            <Link
              to="https://webxsecure.in/contact"
              className="group inline-flex items-center gap-2 px-5 py-3 rounded-lg bg-primary text-white font-semibold shadow-[0_0_40px_rgba(254,120,83,0.35)] hover:scale-105 transition-all duration-300"
            >
              Start Your Project{" "}
              <ArrowUpRight className="w-5 h-5 group-hover:translate-x-1 group-hover:-translate-y-1 transition duration-300" />
            </Link>
          </div>

          {/* RIGHT */}
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-5">
            {companies.map((item, index) => (
              <div
                key={index}
                className="rounded-lg border border-gray-600/20 dark:border-white/10 bg-[#fafafa] dark:bg-white/5 backdrop-blur-2xl p-4 flex flex-col items-center justify-center hover:scale-105"
              >
                <div className={`text-4xl mb-3 ${item.color}`}>{item.icon}</div>

                <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                  {item.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
